import { ModuleSubtype } from 'sigma-mappings';

const Chromatography = () => import(/* webpackChunkName: "chromatography" */ '@/app/installation/engineering/modules/chromatography');
const PhysicalChemical = () => import(/* webpackChunkName: "physicalChemical" */ '@/app/installation/engineering/modules/physicalChemical');
const CommutatorMaintenance = () => import(/* webpackChunkName: "commutatorMaintenance" */ '@/app/installation/engineering/modules/commutatorMaintenance');
const CommutatorTemperatureDifferential = () => import(/* webpackChunkName: "commutatorTemperatureDifferential" */ '@/app/installation/engineering/modules/commutatorTemperatureDifferential');
const WaterOnPaper = () => import(/* webpackChunkName: "waterOnPaper" */ '@/app/installation/engineering/modules/waterOnPaper');
const IsolationAging = () => import(/* webpackChunkName: "isolationAging" */ '@/app/installation/engineering/modules/isolationAging');
const FinalGradient = () => import(/* webpackChunkName: "finalGradient" */ '@/app/installation/engineering/modules/finalGradient');
const CoolingEfficiency = () => import(/* webpackChunkName: "coolingEfficiency" */ '@/app/installation/engineering/modules/coolingEfficiency');
const CoolingMaintenance = () => import(/* webpackChunkName: "coolingMaintenance" */ '@/app/installation/engineering/modules/coolingMaintenance');
const LoadSimulation = () => import(/* webpackChunkName: "loadSimulation" */ '@/app/installation/engineering/modules/loadSimulation');

export default {
  [ModuleSubtype.PHYSICAL_CHEMICAL]: PhysicalChemical,
  [ModuleSubtype.CHROMATOGRAPHY]: Chromatography,
  [ModuleSubtype.COMMUTATOR_TEMPERATURE_DIFFERENTIAL]: CommutatorTemperatureDifferential,
  [ModuleSubtype.COMMUTATOR_MAINTENANCE]: CommutatorMaintenance,
  [ModuleSubtype.WATER_ON_PAPER]: WaterOnPaper,
  [ModuleSubtype.ISOLATION_AGING]: IsolationAging,
  [ModuleSubtype.FINAL_GRADIENT_WINDING]: FinalGradient,
  [ModuleSubtype.COOLING_EFFICIENCY]: CoolingEfficiency,
  [ModuleSubtype.COOLING_MAINTENANCE]: CoolingMaintenance,
  [ModuleSubtype.LOAD_SIMULATION]: LoadSimulation,
};
